
import React from 'react';

const CarrierSelection = ({ carriers, selectedCarrier, setSelectedCarrier, loadingCarriers }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-white mb-1">Select Carrier</label>
      <select
        value={selectedCarrier}
        onChange={(e) => setSelectedCarrier(e.target.value)}
        className="w-full px-4 py-2 rounded-lg bg-[#222] text-white border border-[#DBAE6E] focus:outline-none focus:ring-2 focus:ring-[#DBAE6E] transition-all"
        disabled={loadingCarriers}
      >
        <option value="">Select a carrier</option>
        {carriers.map((carrier) => (
          <option key={carrier.id || carrier.name} value={carrier.name}>
            {carrier.name} {carrier.description ? ` - ${carrier.description}` : ''}
          </option>
        ))}
      </select>
      {loadingCarriers && <p className="text-sm text-gray-400 mt-1">Loading carriers...</p>}
    </div>
  );
};

export default CarrierSelection;
